import { render, staticRenderFns } from "./diff.vue?vue&type=template&id=af22e382&scoped=true&lang=pug&"
import script from "./diff.vue?vue&type=script&lang=ts&"
export * from "./diff.vue?vue&type=script&lang=ts&"
import style0 from "./diff.vue?vue&type=style&index=0&id=af22e382&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af22e382",
  null
  
)

export default component.exports